module.exports = __webpack_public_path__ + "img/1-1_08.eb832761.jpg";